const navigation = [
    { title: "Pacientes", path: "/app/pacientes", icon: 'FaUserFriends' },
    { title: "Notificações por SMS", path: "/app/notificacoes", icon: 'FiMail' },
    { title: "API", path: "/app/api", icon: 'FiGitPullRequest' },
    { title: "WebHooks", path: "/app/webhooks", icon: 'FiShuffle' },
]

export default navigation;